export default {
    symbolsKeyValue: "Abc",
    layout: [
        ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
        ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
        ["z", "x", "c", "v", "b", "n", "m"]
    ],
    specialKeysLayout: ["é", "è", "ê", "à", "ù", "ç", "ô", "î", "ï", "ë", "û"],
    specialKeysLabel: "éèà"
};
